//* 미션 항목의 url이 현재 페이지로 그대로 돌아오는지 판정한다 —
//* 출석 페이지의 '출석체크' 미션처럼 자기 자신으로 가는 항목(무한루프)을 숨기는 데 쓴다.
export const isSelfReferencingMenuUrl = (
  url: string | undefined,
  currentPathname: string,
): boolean => {
  if (!url) {
    return false;
  }

  try {
    const targetPathname = new URL(url, 'https://www.welfarehello.com')
      .pathname;

    return (
      targetPathname.replace(/\/+$/, '') === currentPathname.replace(/\/+$/, '')
    );
  } catch {
    return false;
  }
};
